import React, { Component } from 'react';
import { Text } from 'components/styled/ui';
import { OutlineDropdown } from 'components/layouts';
import { connect } from 'react-redux';
import { getData, dataReceived } from 'datahub/actions';
import { setOrder } from 'filters/actions';
import { filterData } from 'filters/selectors';
import dataService from 'api/dataService';
import { strings } from 'config';

class Sorting extends Component {
  state = {};

  onSortChange = sortOption => {
    const { filters, handleFilters } = this.props;

    const filteredResult = {
      ...filters,
      ...{
        headerSort: {
          name: 'created_at',
          sort: sortOption
        }
      }
    };

    handleFilters(filteredResult);
  };

  render() {
    const sortList = [
      {
        label: strings.sorting.recentlyAdded,
        value: 'desc'
      },
      {
        label: strings.sorting.oldestFirst,
        value: 'asc'
      }
    ];

    return (
      <div className="sort-options">
        <Text.span size={14} style={{ padding: '6px 0', display: 'inline-block' }}>
        {strings.sorting.sortBy}
        </Text.span>
        <OutlineDropdown onSortChange={this.onSortChange} items={sortList} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    filters: state.filters
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleFilters: filters => {
      dispatch(setOrder(filters.headerSort));
      const queryParams = filterData(filters);
      dispatch(getData());
      dataService.getDataList(queryParams).then(response => {
        dispatch(dataReceived(response));
      });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Sorting);



// WEBPACK FOOTER //
// ./src/components/layouts/sorting/sorting.js